import { useEffect, useState } from 'react'
import { Stats } from './Stats'
import Spinner from 'app/components/Spinner'
import { Tooltip } from 'app/components/Tooltip'
import { bg } from 'lib/background'

type Props = {
  title: string
  count: number
  requestPath: string
  createBreakdownFromResponse: (response: any) => { colorHex?: string | undefined; name: string; count: number }[]
  children: React.ReactElement
  className?: string
}

export function LazyStats(props: Props): React.ReactElement {
  const [breakdown, setBreakdown] = useState<{ colorHex?: string | undefined; name: string; count: number }[]>()
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setBreakdown(undefined)
    setLoading(false)
  }, [props.requestPath])

  function getBreakdown() {
    if (loading) return
    setLoading(true)
    bg(async () => {
      let resp = await fetch(props.requestPath)
      let body: Record<string, number> = await resp.json()
      setBreakdown(() => props.createBreakdownFromResponse(body))
    })
  }
  return (
    <>
      {breakdown ? (
        <Stats title={props.title} count={props.count} breakdown={breakdown}>
          {props.children}
        </Stats>
      ) : (
        <Tooltip
          placement="bottom"
          onMouseOver={() => (props.count > 0 ? getBreakdown() : null)}
          message={props.count > 0 ? <Spinner size={5} /> : undefined}
        >
          <div className="flex h-full w-full items-center justify-start px-2 text-body-xs">
            <span className="group-hover/cell:stats-hover">{props.children}</span>
          </div>
        </Tooltip>
      )}
    </>
  )
}
